import { useEffect, useState } from 'react';

import { MOBILE_BREAKPOINT } from '@/lib/theme';

const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT})`;

// Every phone browser puts "Mobi" in its user agent, so a phone held sideways stays a phone. The
// width still counts too, because a desktop window made narrow needs the phone layout as well.
const isPhone = typeof navigator !== 'undefined' && /Mobi/.test(navigator.userAgent);

export const isMobileScreen = () => isPhone || window.matchMedia(MOBILE_MEDIA_QUERY).matches;

export function useMediaQuery() {
  const [isNarrow, setIsNarrow] = useState<boolean>(() => {
    if (typeof window !== 'undefined') return window.matchMedia(MOBILE_MEDIA_QUERY).matches;

    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsNarrow(event.matches);

    setIsNarrow(mediaQuery.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const isMobile = isPhone || isNarrow;

  return { isMobile, isDesktop: !isMobile };
}
